import state from '~store/modules/contracts/state'
import actions from '~store/modules/contracts/actions'

export default {
  state,
  actions
}
